import React, { Suspense, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet, Navigate } from 'react-router-dom';
import { Layout, Spin } from 'antd';
import AuthContext from './contexts/authProvider';
import SettingContext from './contexts/settingProvider';
import Login from './pages/Login';
import Header from './components/Header';
import Sidebar from './components/SideBar';
import Footer from './components/Footer';

const CustomerList = React.lazy(() => import('./pages/CustomerList'));
const NotFound = React.lazy(() => import('./pages/NotFound'));
const Settings = React.lazy(() => import('./pages/Settings'));
const CustomerInfo = React.lazy(() => import('./pages/CustomerInfo'));
const AddEvaluation = React.lazy(() => import('./pages/AddEvaluation'));
const EvaluationView = React.lazy(() => import('./pages/EvaluationView'));

function NavWrapper() {
  const { user } = useContext(AuthContext);
  const { dark } = useContext(SettingContext);
  if (!user) return <Navigate to="/login" />;

  return (
    <Layout hasSider className={`app-layout ${dark ? 'dark' : ''}`}>
      <Sidebar />
      <Layout className="app-background">
        <Header />
        <Suspense
          fallback={
            <div className="app-content loading" style={{ width: '100%' }}>
              <Spin size="large" />
            </div>
          }
        >
          <Outlet />
        </Suspense>
        <Footer />
      </Layout>
    </Layout>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/evaluationview/:id" element={<EvaluationView />} />
        <Route path="/" element={<NavWrapper />}>
          <Route path="/" element={<Navigate replace to="/customerlist" />} />
          <Route path="/customerlist" element={<CustomerList />} />
          <Route path="/customerlist/:id" element={<CustomerInfo />} />
          <Route path="/customerlist/:id/addevaluation" element={<AddEvaluation />} />
          <Route path="/customerlist/:id/evaluation/:evalId" element={<EvaluationView />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
